
import { defineComponent } from 'vue'
import EmailSvg from "@/components/svgs/EmailSvg.vue"
import FacebookSvg from '@/components/svgs/FacebookSvg.vue'
import InstagramSvg from '@/components/svgs/InstagramSvg.vue'
import LocationSvg from "@/components/svgs/LocationSvg.vue"
import PhoneSvg from '@/components/svgs/PhoneSvg.vue'
import YoutubeSvg from '@/components/svgs/YoutubeSvg.vue'

export default defineComponent({
  components: {
    EmailSvg,
    FacebookSvg,
    InstagramSvg,
    LocationSvg,
    PhoneSvg,
    YoutubeSvg
  },
  computed: {
    copyrightText(): string {
      return `Short Action Customs, LLC. © ${new Date().getFullYear()}. All rights reserved.`
    }
  }
})
